import React, { useState } from "react";
import PropTypes from "prop-types";
import Footer from "./Footer";
import Header from "./Header";
import Menu from "../common/Menu";
import "../common/Submit.css";

const Layout = ({
  children,
  setShowTooltip = () => {},
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="flex flex-col h-full" id="outer-container">
      <div className={`relative ${menuOpen ? "" : "max-w-page"}`}>
        <Menu
          handleToggle={(state) => {
            setMenuOpen(state.isOpen);
          }}
          hidden={menuOpen}
        />
      </div>
      <div className="xtopSection" id="page-wrap">
        <div className="headerBar fixed">
          <Header
            setShowTooltip={(a) => {
              setShowTooltip(a);
            }}
          />
        </div>
        <div className="bg-black flex pt-[60px] lg:pt-24 min-h-screen">
          <main className="w-full text-white overflow-hidden">
            {children}
          </main>
        </div>
        <div className="w-full text-dark overflow-hidden">
          <Footer />
        </div>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  setShowTooltip: PropTypes.func,
};

export default Layout;
